export default "__VITE_ASSET__BuLGYjFr__"